import { shape, string, arrayOf, bool, oneOf } from 'prop-types';
import { types } from 'common/store/search/advanced/criteria';
import { constraintShape } from './constraint';

const criteriaShape = shape({
  property: string.isRequired,
  nullable: bool.isRequired,
  constraints: arrayOf(constraintShape),
  type: oneOf(Object.values(types)),
});

export default criteriaShape;
